const mutils = globalThis.mutils = {
    wait(t) {
        return new Promise(resolve => {
            setTimeout(resolve, t);
        });
    },
    extend(target, ...sources) {
        sources.forEach(source => {
            for (const key in source) {
                const value = source[key];

                if (typeof value == 'object') {
                    if (typeof target[key] == 'object') {
                        mutils.extend(target[key], value);
                        continue;
                    }
                }

                target[key] = value;
            }
        });
    },
    createElement(tagName, properties={}, children=[]) {
        const element = document.createElement(tagName);

        mutils.extend(element, properties);

        children.forEach(child => {
            element.appendChild(child);
        });

        return element;
    },
    radToDeg(radians) {
        return (180 / Math.PI) * radians;
    },
    degToRad(degrees) {
        return (Math.PI / 180) * degrees;
    },
    rotate(x, y, radians) {
        const cos = Math.cos(radians);
        const sin = Math.sin(radians);
        const nx = (cos * x) + (sin * y);
        const ny = (cos * y) - (sin * x);

        return [nx, ny];
    },
    random(min, max) {
        if (max == undefined) {
            max = min;
            min = 0;
        }

        return Math.random()*(max-min)+min;
    },
    distance(x1, y1, x2, y2) {
        const a = x1 - x2;
        const b = y1 - y2;

        return Math.hypot(a, b);
    }
};
